import { formatPrice, formatPriceRange } from '../currency';

/**
 * Thin wrappers around `modules/currency.formatPrice` for the shipping
 * module. Accept the amount in the currency's main unit (dollars/euros —
 * as returned by the backend). Read the currency from sessionStorage
 * synchronously — no hook, no reactivity.
 */
export function formatMoney(n: number): string {
  if (!Number.isFinite(n)) return '—';
  return formatPrice(n);
}

export function formatMoneyRange(min: number, max: number): string {
  if (!Number.isFinite(min) || !Number.isFinite(max)) return '—';
  return formatPriceRange(min, max);
}
